import { ReactElement, memo } from 'react';
import ImageComponent from '@spa/components/image-component/image.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import styles from './free-samples-banner.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';

export interface Props {
  readonly numberOfSamples: number;
  readonly className?: string;
}

export function FreeSamplesBannerComponent({ numberOfSamples, className }: Props): ReactElement {
  const { formatMessage }: NamespacedIntl = useNamespacedIntl('free-samples-banner');

  return (
    <span className={`${styles['free-samples-banner']} ${className}`}>
      <ImageComponent
        src={'/assets/icons/free-samples.svg'}
        alt={'free-samples-icon'}
        height={33}
        width={32}
      />
      <span
        dangerouslySetInnerHTML={{
          __html: formatMessage('freeSamplesMessage', { max: numberOfSamples?.toString() })
        }}
      />
    </span>
  );
}

export default memo(FreeSamplesBannerComponent);
